
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CropperSettings, Bounds, ImageCropperComponent } from "ng2-img-cropper";
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { HeaderBodyResource } from "app/models/HeaderBodyResource";
import { HeaderService } from "app/homepage-configuration/header/header.service";

@Component({
  selector: 'vbn-header-body',
  templateUrl: './header-body.component.html',
  styleUrls: ['./header-body.component.scss'],
  providers: [HeaderService]
})
export class HeaderBodyComponent implements OnInit {

  //text1
  showButtonImageText1: boolean = true;
  showCropImageText1: boolean = false;
  resultImgText1: boolean = false;
  imageCrtText1: boolean = true;
  cropperSettingsText1: CropperSettings;
  croppedImgText1: any;
  isInvalidImgSizeText1: boolean = false;
  showCropBtnText1: boolean = true;
  selectedOption: boolean;
  selected_language: string = "ro";
  showConfirmationText;

  //text2
  showButtonImageText2: boolean = true;
  showCropImageText2: boolean = false;
  resultImgText2: boolean = false;
  imageCrtText2: boolean = true;
  cropperSettingsText2: CropperSettings;
  croppedImgText2: any;
  isInvalidImgSizeText2: boolean = false;
  showCropBtnText2: boolean = true;
  selectedOptionText2: boolean;
  selected_languageText2: string = "ro"

  //variables
  dateNow: Date;
  image: any = new Image();
  // showLogoConfig: boolean = false;
  // showText1Config: boolean = false;
  // showText2Config: boolean = false;
  // showOthersConfig: boolean = false;
  selectedCell: boolean;
  headerBodyResource: HeaderBodyResource;
  errorMessage: any;
  
  @ViewChild('cropper2', undefined) cropper2:ImageCropperComponent;
  @ViewChild('cropper3', undefined) cropper3:ImageCropperComponent;

  constructor(
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private headerService: HeaderService) {
    //text1
    this.cropperSettingsText1 = new CropperSettings();
    this.cropperSettingsText1.croppedWidth = 250;
    this.cropperSettingsText1.croppedHeight = 150;
    this.cropperSettingsText1.canvasWidth = 250;
    this.cropperSettingsText1.canvasHeight = 150;
    this.cropperSettingsText1.keepAspect = true;
    this.cropperSettingsText1.width = 250;
    this.cropperSettingsText1.height = 150;
    this.croppedImgText1 = {};
    this.selectedOption = true;
    //text2
    this.cropperSettingsText2 = new CropperSettings();
    this.cropperSettingsText2.croppedWidth = 250;
    this.cropperSettingsText2.croppedHeight = 150;
    this.cropperSettingsText2.canvasWidth = 250;
    this.cropperSettingsText2.canvasHeight = 150;
    this.cropperSettingsText2.keepAspect = true;
    this.cropperSettingsText2.width = 250;
    this.cropperSettingsText2.height = 150;
    this.croppedImgText2 = {};
    this.selectedOptionText2 = true;
    //other
    this.dateNow = new Date();
    this.selectedCell = false;
    this.headerBodyResource = new HeaderBodyResource();
  }

  ngOnInit() {
    this.getBody();
  }

  cropped(bounds: Bounds) {
    //console.log(bounds);
    // if(this.isInvalidImgSizeLogo){
    //   this.clearLogo();
    // }
    if(this.isInvalidImgSizeText1){
      this.clearText1();
    }
    if(this.isInvalidImgSizeText2){
      this.clearText2();
    }
  }

  //text1
  openImageSelectText1() {
    this.showButtonImageText1 = false;
    this.showCropImageText1 = true;
    this.croppedImgText1 = {};
  }

  cancelImageText1() {
    this.showCropImageText1 = false;
    this.showButtonImageText1 = true;
  }

  saveImageCroppedText1(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.headerBodyResource.cellOneImageString = imgCrop;
      this.image.src = "";
      this.showCropImageText1 = false;
      this.imageCrtText1 = false;
      this.resultImgText1 = true;
      this.showButtonImageText1 = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  clearText1() {
    this.croppedImgText1 = {};
    this.cropper2.reset();
    return;
  }

  // saveText1(){
  //   if(this.selectedOption){
      
  //   } else {
  //     // this.errorTextRO = true;
  //     // this.errorTextFR = true;
  //     // this.errorTextEN = true;
  //   }
  // }

  //text2
  openImageSelectText2() {
    this.showButtonImageText2 = false;
    this.showCropImageText2 = true;
    this.croppedImgText2 = {};
  }

  cancelImageText2() {
    this.showCropImageText2 = false;
    this.showButtonImageText2 = true;
  }

  saveImageCroppedText2(imgCrop) {
    if (imgCrop != null && imgCrop != '') {
      this.headerBodyResource.cellTwoImageString = imgCrop;
      this.image.src = "";
      this.showCropImageText2 = false;
      this.imageCrtText2 = false;
      this.resultImgText2 = true;
      this.showButtonImageText2 = true;
      // console.log("---------", this.croppedEditImg)
    }
  }

  clearText2() {
    this.croppedImgText2 = {};
    this.cropper3.reset();
    return;
  }

  // saveText2(){
  //   if(this.selectedOptionText2){
      
  //   } else {
  //     // this.errorTextRO2 = true;
  //     // this.errorTextFR2 = true;
  //     // this.errorTextEN2 = true;
  //   }
  // }

  //others
  // saveOthers(){
    
  // }

  // showLogo() {
  //   this.showLogoConfig = true;
  //   this.showText1Config = false;
  //   this.showText2Config = false;
  //   this.showOthersConfig = false;
  // }

  // showText1() {
  //   this.showLogoConfig = false;
  //   this.showText1Config = true;
  //   this.showText2Config = false;
  //   this.showOthersConfig = false;
  // }

  // showText2() {
  //   this.showLogoConfig = false;
  //   this.showText1Config = false;
  //   this.showText2Config = true;
  //   this.showOthersConfig = false;
  // }

  // showOthers() {
  //   this.showLogoConfig = false;
  //   this.showText1Config = false;
  //   this.showText2Config = false;
  //   this.showOthersConfig = true;
  // }

  checkFile(event){
    console.log(event)
    let file = event.target.files[0];
    this.isInvalidImgSizeText1 = false;
    this.isInvalidImgSizeText2 = false;
    this.showCropBtnText1 = true;
    this.showCropBtnText2 = true;
    if (file.type == "image/jpeg" || file.type == "image/JPEG" || file.type == "image/jpg" || file.type == "image/JPG" 
          || file.type == "image/png" ||  file.type == "image/PNG" || file.type == "image/gif" || file.type == "image/GIF"
          || file.type == "image/bitmap" || file.type == "image/BITMAP" || file.type == "image/tiff" || file.type == "image/TIFF") {
            if(file.size > 2000000) {
              observableForkJoin(
                this.translate.get('Error'),
                this.translate.get('Maximum size of image is 2 MB!')
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
              event.target.value = "";
              if(event.currentTarget.id == 2){
                this.isInvalidImgSizeText1 = true;
                this.showCropBtnText1 = false;
              }
              if(event.currentTarget.id == 3){
                this.isInvalidImgSizeText2 = true;
                this.showCropBtnText2 = false;
              }
              console.log(event)
              return;
            } 
        console.log()
      } else {
        observableForkJoin(
            this.translate.get('Error'),
            this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF, TIFF, BITMAP!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
          return;
      }
  }

  getBody() {
    this.headerService.getHeaderBody('/admin/header/headerBody/getOne')
      .subscribe(
        body => {
          this.headerBodyResource = body;
          this.selectedCell= this.headerBodyResource.hasTwoCells;
          this.selectedOption = this.headerBodyResource.cellOneText;
          this.selectedOptionText2 = this.headerBodyResource.cellTwoText;
        },
        error => this.errorMessage = <any>error)
  }

  saveBody(){
    this.headerBodyResource.hasTwoCells = this.selectedCell;
    this.headerBodyResource.cellOneText = this.selectedOption;
    this.headerBodyResource.cellTwoText = this.selectedOptionText2;
    this.headerService.saveHeaderBody(`/admin/header/headerBody/edit`, this.headerBodyResource)
      .subscribe(
        body => {
          this.headerBodyResource = body;
          this.dateNow = new Date();
          this.resultImgText1 = false;
          this.imageCrtText1 = true;
          this.resultImgText2 = false;
          this.imageCrtText2 = true;
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Header body saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
        },
        error => console.error(error))
  }

  cancelBody(){
    this.getBody();
  }
}
